import GcpTable from '@console/components/project/brandCheck/GcpTable';
import type { AppState } from '@console/reducers';
import { getGiftCardConfigsForDisplay } from '@console/selectors/projectDetail/giftCardConfigs';
import { getGifteeBoxConfigs } from '@console/selectors/projectDetail/gifteeBoxConfigs';
import { connect } from 'react-redux';

const mapStateToProps = (state: AppState) => ({
  gifteeBoxConfigs: getGifteeBoxConfigs(state),
  giftCardConfigs: getGiftCardConfigsForDisplay(state)
});

const mapDispatchToProps = () => ({});

export type GcpTablePropsMappedFromState = ReturnType<typeof mapStateToProps>;
export type GcpTablePropsMappedFromDispatch = ReturnType<
  typeof mapDispatchToProps
>;

export default connect(mapStateToProps, mapDispatchToProps)(GcpTable);
